import { computed, ComputedRef } from 'vue'

import { Incident } from '@collector/sportsapi-types'
import { useIncidents } from '@desktop/views/Relation/composables'
import { useParticipants } from '@desktop/views/Relation/composables/useParticipants'
import { injectIncidentsResultConfig } from '@desktop/views/Relation/Sports/provide-inject/incidentsResultConfig'

import { buildIncidentResultsMap } from './buildIncidentResultsMap'
import { Result } from './types'

type UseIncidentResult = {
  results: ComputedRef<Map<number, Result>>
  getResult: (incident: Incident) => Result | null
}

export function useIncidentResult(): UseIncidentResult {
  const incidentsResultConfig = injectIncidentsResultConfig()
  const { incidents } = useIncidents()
  const { homeParticipant, awayParticipant } = useParticipants()

  const resultsMap = computed(() => {
    if (!incidentsResultConfig) return new Map<number, Result>()

    const homeTeamId = homeParticipant.value?.id
    const awayTeamId = awayParticipant.value?.id

    if (homeTeamId === undefined || awayTeamId === undefined) {
      return new Map<number, Result>()
    }

    return buildIncidentResultsMap({
      incidents: incidents.value,
      homeTeamId,
      awayTeamId,
      incidentsResultConfig,
    })
  })

  function getResult(incident: Incident): Result | null {
    const { isResultVisible } = incidentsResultConfig || {}

    if (isResultVisible?.(incident) !== false) {
      return resultsMap.value.get(incident.id) ?? null
    }

    return null
  }

  return { results: resultsMap, getResult }
}
